import { createSlice } from "@reduxjs/toolkit";

import { ReduxReducer } from "../../../../../interface";
import { SettingsFinances } from "../../interface";

import { State } from "./interface";

const initialState: State = {
	clients: {},
};

const setOrdersDataModal: ReduxReducer<State, State["clients"]> = (
	state,
	action,
) => {
	for (const [id, data] of Object.entries(action.payload)) {
		const numericId = Number(id);

		if (!Number.isNaN(numericId)) {
			const existing = state.clients[numericId];
			state.clients[numericId] = {
				...existing,
				...data,
			};
		}
	}
};

const settingsFinancesCustomerTariffPlansDataModal = createSlice({
	name: SettingsFinances.ConstantAccountsSlice
		.SETTINGS_MENU_FINANCES_CUSTOMER_TARIFF_PLANS_DATA_MODAL,
	initialState,
	reducers: {
		setOrdersDataModal,
	},
});

export const settingsFinancesCustomerTariffPlansDataModalAction =
	settingsFinancesCustomerTariffPlansDataModal.actions;
export const settingsFinancesCustomerTariffPlansDataModalReducer =
	settingsFinancesCustomerTariffPlansDataModal.reducer;
export type settingsFinancesCustomerTariffPlansDataModalState = State;

export default settingsFinancesCustomerTariffPlansDataModal;
